import transactionFullcont from './transaction-fullcont.html'

const dialog = require('../../../../../components/dialog/dialog')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const fullcontForm = require('../../../../../components/fullcont/fullcont-form')
const transactionDt = require('./transaction-dt')
const transactionMenu = require('./transaction-menu')
const transactionDialog = require('./transaction-dialog')
const dbRequest = require('../../../../../js-network/db-request')
const handler = require('./transaction-fullcont-handler')
const { form } = require('./transaction-fullcont-form')
const { formCopy } = require('./transaction-fullcont-form')

const transactionMT = undefined
const htmlFc = {}
let HTMLwasSelected = false
let deleteInProgress = false

function HTMLselect() {
  fullcontHandler.HTMLselect(
    'transaction',
    'transaction',
    'transaction-fullcont',
    transactionFullcont,
    form,
    formCopy,
    transactionMT,
    editDialog,
    undefined,
    dtCall,
    htmlFc,
  )

  htmlFc.addOne = 'server/php/sql/InsertTransation.php'
  htmlFc.update = 'server/php/sql/updateTransation.php'
  htmlFc.selectOne = 'server/php/sql/selectOneTransation.php'
  HTMLwasSelected = true
}

export function start(detail) {
  if (!HTMLwasSelected) HTMLselect()

  obj[detail.act].start(detail)
}

const obj = {
  addOne: { start: (detail) => addOne(detail) },
  discard: { start: (detail) => discard(detail) },
  hide: { start: (detail) => hide(detail) },
  prepareAdd: { start: (detail) => prepareAdd(detail) },
  selectOne: { start: (detail) => selectOne(detail) },
  prepareEdit: { start: (detail) => prepareEdit(detail) },
  cancelEdit: { start: (detail) => fullcontEntity.cancelEdit(detail, htmlFc) },
  update: { start: (detail) => update(detail) },
  fullcontOptions: { start: (detail) => {
    if (canDelete()) transactionMenu.start(detail, undefined, htmlFc)
  } },
  deleteEntity: { start: (detail) => deleteEntity(detail) },
  deleteFromDialog: { start: (detail) => deleteFromDialog(detail) },
  prepareBouncedCheck: { start: (detail) => prepareBouncedCheck(detail) },
  saveFromDialog: { start: (detail) => saveFromDialog(detail) },
  syncBouncedCheckReceivepayment: { start: () => handler.syncBouncedCheckReceivepayment(htmlFc) },
  syncTransactionType: { start: () => handler.syncTransactionType(htmlFc) },
  toggleAssetDepreciation: { start: () => handler.toggleAssetDepreciation(htmlFc) },
}

// Guarda solo los campos de la subentidad seleccionada mediante el framework.
function addOne(detail) {
  if (!htmlFc.fullcontHTML.classList.contains('mode-add')) return

  const insertContext = handler.getSaveContext(htmlFc)
  fullcontEntity.addOne(detail, insertContext, (data, result) => {
    handler.afterSave(htmlFc, data, result)
  })
}

// Solo se edita una subentidad que ya fue guardada; el selector de tipo sigue bloqueado.
function prepareEdit(detail) {
  if (!htmlFc.savedTransactionType) return
  fullcontHandler.prepareEdit(detail, htmlFc)
}

// El ID del DT identifica un movimiento; el fullcont conserva el ID de la subentidad original.
function selectOne(detail) {
  if (!['account_transfer', 'asset_disposal', 'bounced_check', 'bank_fees', 'card_payment', 'depreciation', 'equity_deposit', 'equity_withdrawal', 'loan_issued', 'loan_issued_payment', 'loan_payment', 'loan_received', 'operating_expense', 'other_income', 'other_receivable', 'asset_purchase'].includes(detail.transactionType)) return
  if (fullcontForm.wasEdited(htmlFc)) {
    editDialog()
    return
  }

  const selectContext = handler.getTypeContext(htmlFc, detail.transactionType)
  fullcontEntity.selectOne(detail, selectContext, (data, result) => {
    handler.afterSelect(htmlFc, data, result)
    fullcontHandler.setDbid({ ...detail, dbid: data.id })
  })
}

function update(detail) {
  if (!htmlFc.savedTransactionType || !htmlFc.fullcontHTML.classList.contains('mode-edit')) return

  const updateContext = handler.getSaveContext(htmlFc)
  fullcontEntity.update(detail, updateContext, (data, result) => {
    handler.afterSave(htmlFc, data, result)
  })
}

// El registro guardado permite borrar desde vista o edicion, respetando los permisos de solo lectura.
function canDelete() {
  return ['account_transfer', 'asset_disposal', 'bounced_check', 'bank_fees', 'card_payment', 'depreciation', 'equity_deposit', 'equity_withdrawal', 'loan_issued', 'loan_issued_payment', 'loan_payment', 'loan_received', 'operating_expense', 'other_income', 'other_receivable', 'asset_purchase'].includes(htmlFc.savedTransactionType)
    && htmlFc.fullcontHTML.classList.contains('fullcont-show')
    && !htmlFc.fullcontHTML.classList.contains('mode-add')
    && (htmlFc.fullcontHTML.classList.contains('mode-view')
      || htmlFc.fullcontHTML.classList.contains('mode-edit'))
    && !htmlFc.fullcontHTML.classList.contains('mode-readOnly')
}

function deleteEntity(detail) {
  if (!canDelete() || deleteInProgress || detail.id !== 'transaction-fullcont') return
  const recordId = htmlFc.fullcontHTML.getAttribute('data-dbid')
  if (String(detail.dbid) !== recordId || !/^[1-9][0-9]*$/.test(recordId)) return

  transactionDialog.start({ act: 'show', id: 'deleteTransaction', dbid: recordId, transactionType: htmlFc.savedTransactionType })
}

// La ruta generica de borrado es fija; esta entidad usa su endpoint propio, como Retail.
async function deleteFromDialog(detail) {
  if (!canDelete() || deleteInProgress) return
  if (detail.transactionType !== htmlFc.savedTransactionType) return
  const recordId = htmlFc.fullcontHTML.getAttribute('data-dbid')
  if (String(detail.dbid) !== recordId || !/^[1-9][0-9]*$/.test(recordId)) return

  deleteInProgress = true
  const transactionType = htmlFc.savedTransactionType
  try {
    const result = await dbRequest.start({ inf: {
      entity: 'transaction', transaction_type: transactionType, id: recordId,
    } }, 'server/php/sql/deleteTransation.php')
    if (result.status !== 'ok') throw new Error('The transaction could not be deleted. Please try again.')
    if (result.restriction?.val !== 'ok') {
      throw new Error(result.extrainfo?.message || 'The transaction could not be deleted.')
    }

    // Cierra y descarta el formulario solo despues de confirmar el commit del servidor.
    if (htmlFc.fullcontHTML.getAttribute('data-dbid') === recordId && htmlFc.savedTransactionType === transactionType) {
      discard({ dest: 'transaction', id: 'transaction-fullcont' })
      htmlFc.savedTransactionType = ''
      htmlFc.fullcontHTML.removeAttribute('data-dbid')
    }
    dtCall('deleteRow', [{ id: recordId, transaction_type: transactionType }])
  } catch (error) {
    // Espera a que termine el cierre de la confirmacion antes de mostrar el rechazo.
    await new Promise(resolve => setTimeout(resolve, 350))
    transactionDialog.start({ act: 'show', id: 'deleteError', message: error.message })
  } finally {
    deleteInProgress = false
  }
}

// El dialogo conserva el mismo flujo de Save/Update que los botones del fullcont.
function saveFromDialog(detail) {
  if (htmlFc.fullcontHTML.classList.contains('mode-add')) {
    addOne(detail)
  } else {
    update(detail)
  }
}

function prepareAdd(detail) {
  fullcontEntity.prepareAdd(detail, htmlFc, handler.prepareAdd)
}

function prepareBouncedCheck(detail) {
  const prepared = fullcontEntity.prepareAdd(detail, htmlFc, handler.prepareAdd)

  if (!prepared) return

  handler.prepareBouncedCheck(htmlFc, detail.receivepayment)
}

function hide(detail) {
  fullcontEntity.hide(detail, htmlFc)
}

function discard(detail) {
  fullcontHandler.discard(detail, htmlFc)
}

function editDialog() {
  dialog.start({ act: 'show', id: 'saveChanges', entity: 'transaction' })
}

function dtCall(act, rows) {
  // Una subentidad genera movimientos con IDs distintos al ID que recibe el fullcont.
  if (document.getElementById('transaction-dt')) {
    if (['addRow', 'updateRow', 'deleteRow'].includes(act) && rows?.[0]) {
      transactionDt.start({ act: 'fullcontChanged', operation: act, record: rows[0] })
    } else {
      transactionDt.start({ act: 'refresh', dest: 'transaction' })
    }
  }
}
